module.exports = __webpack_public_path__ + "img/credit_card.5d1e259c.png";